import React from 'react';
import {RelayEnvironmentProvider} from 'react-relay';
import {RelayEnvironment} from './forecastRelay';

export function RelayProvider({children}: {children: React.ReactNode}) {
	return <RelayEnvironmentProvider environment={RelayEnvironment.getInstance()}>{children}</RelayEnvironmentProvider>;
}
